import { useState } from 'react';
import Modal from '../Modal';
import { ALL_ACCOUNTS_KEY } from '@/components/TourBag/Dashboard/AccountsSelect';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import CheckmarkIcon from '@/assets/icons/checkmark.svg?react';
import styles from './OptionPicker.module.scss';

interface IOption {
  value: string;
  label: string;
}

interface IOptionPickerProps {
  title: string;
  options: IOption[];
  defaultValue: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  className?: string;
  modalClassName?: string;
}

function OptionPicker({ title, options, defaultValue, onChange, className = '', modalClassName = '' }: IOptionPickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue);

  const handleSelect = (value: string) => {
    setSelected(value);
    onChange(value);
    setIsOpen(false);
  };

  const handleClear = () => {
    setSelected(ALL_ACCOUNTS_KEY);
    onChange(ALL_ACCOUNTS_KEY);
    setIsOpen(false);
  };

  return (
    <>
      <div className={`${styles.trigger} ${className}`} onClick={() => setIsOpen(true)}>
        <span>{options.find((opt) => opt.value === selected)?.label}</span>
        <ArrowDownIcon />
      </div>

      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} className={modalClassName}>
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <div className={styles.title}>{title}</div>
            {/* Change the selected value on clear if required */}
            <button className={styles.clear} onClick={handleClear}>
              Clear
            </button>
          </div>
          <div className={styles.optionsWrapper}>
            <ul className={styles.options}>
              {options.map((opt) => {
                const isSelected = opt.value === selected;
                return (
                  <li key={opt.value} className={isSelected ? styles.selected : ''} onClick={() => handleSelect(opt.value)}>
                    {opt.label} {isSelected ? <CheckmarkIcon className={styles.checkmark} /> : null}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default OptionPicker;
